import { render } from "./EventoView.vue?vue&type=template&id=05fc1429&scoped=true"
import script from "./EventoView.vue?vue&type=script&lang=js"
export * from "./EventoView.vue?vue&type=script&lang=js"

import "./EventoView.vue?vue&type=style&index=0&id=05fc1429&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05fc1429"]])

export default __exports__